import React, { useState } from 'react';
import { Box, Typography, Grid2, Paper, Button, useTheme, Icon, Tabs, Tab } from '@mui/material';
import Section from './Section';

const SeccionVenderBoleto = () => {
  const theme = useTheme();
  const [tabIndex, setTabIndex] = useState(0);

  const opcion1Steps = [
    'Ingresa a la app y abre la rifa que deseas gestionar.',
    'En la pestaña Tablero, toca los números que deseas vender.',
    'Se abrirá el formulario para asignar el estado (Reservado o Pagado).',
    'Ingresa los datos del comprador: nombre, código de país, teléfono y correo (opcional).',
    'Presiona Actualizar: se registrará la venta y se enviará la confirmación por WhatsApp.',
  ];

  const opcion2Steps = [
    'Ingresa a la app y selecciona tu rifa.',
    'Ve a la pestaña Ventas para ver el listado completo de boletos.',
    'Toca el menú de opciones (...) del número que deseas asignar.',
    'Elige el estado (Reservado o Pagado) y completa los datos del comprador.',
    'Guarda los cambios: el comprador recibirá su comprobante digital de inmediato.',
  ];

  const currentSteps = tabIndex === 0 ? opcion1Steps : opcion2Steps;

  return (
    <Section
      title="¿Cómo Vender un Boleto?"
      subtitle="Tienes dos métodos prácticos para registrar ventas: directamente desde el tablero visual o desde el listado de ventas:"
      hasBackground={false}
      id="vender-boleto"
    >
      <Grid2 container spacing={4} alignItems="center">
        {/* Selector de Modalidad + Pasos */}
        <Grid2 size={{ xs: 12, md: 8 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2.5, sm: 3.5 },
              borderRadius: '16px',
              bgcolor: theme.palette.background.paper,
              border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(45, 52, 132, 0.08)',
              boxShadow: theme.palette.mode === 'dark' ? '0 4px 20px rgba(0, 0, 0, 0.4)' : '0 4px 16px rgba(26, 31, 82, 0.04)',
            }}
          >
            <Tabs
              value={tabIndex}
              onChange={(e, v) => setTabIndex(v)}
              sx={{
                mb: 3,
                borderBottom: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #e2e8f0',
                '& .MuiTab-root': {
                  fontWeight: 800,
                  textTransform: 'none',
                  fontSize: '0.95rem',
                  color: theme.palette.text.secondary,
                  '&.Mui-selected': {
                    color: theme.palette.mode === 'dark' ? '#818cf8' : theme.palette.primary.main,
                  },
                },
              }}
            >
              <Tab icon={<Icon sx={{ color: theme.palette.mode === 'dark' ? '#818cf8' : theme.palette.primary.main }}>dialpad</Icon>} iconPosition="start" label="Opción 1: Desde el Tablero" />
              <Tab icon={<Icon sx={{ color: theme.palette.mode === 'dark' ? '#818cf8' : theme.palette.primary.main }}>view_list</Icon>} iconPosition="start" label="Opción 2: Desde el Listado de Ventas" />
            </Tabs>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {currentSteps.map((step, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.8,
                    p: 1.4,
                    borderRadius: '12px',
                    bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#ffffff',
                    border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.06)' : '1px solid rgba(0, 0, 0, 0.06)',
                    boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 2px 6px rgba(26, 31, 82, 0.03)',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      borderColor: theme.palette.mode === 'dark' ? 'rgba(99, 102, 241, 0.4)' : 'rgba(45, 52, 132, 0.2)',
                      transform: 'translateX(2px)',
                    },
                  }}
                >
                  {/* Badge numerado idéntico a rauh-rifas */}
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      fontSize: '0.85rem',
                      fontWeight: 900,
                      bgcolor: theme.palette.mode === 'dark' ? 'rgba(99, 102, 241, 0.16)' : 'rgba(45, 52, 132, 0.08)',
                      color: theme.palette.mode === 'dark' ? '#818cf8' : theme.palette.primary.main,
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    {index + 1}
                  </Box>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
                    {step}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid2>

        {/* Video Tutorial Card */}
        <Grid2 size={{ xs: 12, md: 4 }}>
          <Paper
            elevation={0}
            sx={{
              p: 3.5,
              borderRadius: '16px',
              bgcolor: theme.palette.background.paper,
              border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(45, 52, 132, 0.1)',
              textAlign: 'center',
              boxShadow: theme.palette.mode === 'dark' ? '0 4px 20px rgba(0, 0, 0, 0.4)' : '0 4px 16px rgba(26, 31, 82, 0.04)',
            }}
          >
            <Box
              sx={{
                width: 52,
                height: 52,
                mx: 'auto',
                mb: 2,
                borderRadius: '12px',
                bgcolor: 'rgba(241, 91, 40, 0.08)',
                color: theme.palette.secondary.main,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon sx={{ fontSize: 28, color: theme.palette.secondary.main }}>smart_display</Icon>
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, color: theme.palette.text.primary }}>
              Tutorial de Ventas
            </Typography>

            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3, lineHeight: 1.6 }}>
              Mira en video cómo registrar ventas y enviar notificaciones automáticas por WhatsApp.
            </Typography>

            <Button
              variant="outlined"
              color="secondary"
              size="large"
              fullWidth
              startIcon={<Icon>play_arrow</Icon>}
              href="https://youtube.com/shorts/3jE8wR8j5vM?si=e_3F6XvV5jV1_5pX"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                py: 1.2,
                fontWeight: 800,
                borderRadius: '8px',
                borderWidth: '1.5px',
                '&:hover': {
                  borderWidth: '1.5px',
                  bgcolor: 'rgba(241, 91, 40, 0.06)',
                },
              }}
            >
              Ver Tutorial
            </Button>
          </Paper>
        </Grid2>
      </Grid2>
    </Section>
  );
};

export default SeccionVenderBoleto;